import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';

// import { DynamicSplashScreenComponent } from './splash-screen/splash-screen.component';

// ?? Shared library (common between admin client and employee portal) ??????????
import { SharedComponentsModule, TimesheetCalendarModule } from 'shared-components';

@NgModule({
    declarations: [
        // DynamicSplashScreenComponent
    ],
    imports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        SharedComponentsModule,       // ? shared library (TableComponent, SortModal, etc.)
        TimesheetCalendarModule       // ? reusable timesheet calendar + time-view cells
    ],
    exports: [
        CommonModule,
        RouterModule,
        ReactiveFormsModule,
        FormsModule,
        NgxPaginationModule,
        // DynamicSplashScreenComponent,
        SharedComponentsModule,       // ? re-export so feature modules get everything
        TimesheetCalendarModule       // ? re-export so feature modules get calendar
    ]
})
export class SharedModule { }
